import { useRef } from 'react'
import crossIcon from '../../assets/icons/crossIcon.svg'
import Button from '../../components/button/Button'
import uploadPinIcon from '../../assets/icons/upload-pin-icon.svg'
import sampleQuestionSet from '../../assets/Sample/sampleQuestionSet.xlsx'
import { UI_CONSTANT } from '../../utility/constants'

function AddTopicDetails({ values, index, moduleIndex, fieldName, onChange, handleRemoveFiles }) {
  const fileRef = useRef()

  const handleSelect = () => {
    if (fileRef.current) {
      fileRef.current.click()
    }
  }

  const files = Array.isArray(values.modules[moduleIndex].topic[index][fieldName])
    ? values.modules[moduleIndex].topic[index][fieldName]
    : [values.modules[moduleIndex].topic[index][fieldName]].filter(Boolean)
  let currentTopicId = values.modules[moduleIndex].topic[index].topicId
  return (
    <>
      <div className='file-name-main'>
        {files.length > 0 ? (
          files.map((file, fileIndex) => (
            <div key={fileIndex} className='topic-uploaded-files-wrapper'>
              <div className='file-name-title'>{file?.name}</div>
              <div className='inner-tab-div'>
                {new Date().toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
                <img src={crossIcon} onClick={() => handleRemoveFiles(fileIndex, file?.name, file?.s3Url, currentTopicId)} />
              </div>
            </div>
          ))
        ) : (
          <div className='topic-uploaded-files-wrapper'>No Files Uploaded</div>
        )}
      </div>
      <hr className='course-content-divider' />
      <div className='course-buttons-file-div'>
        <input
          type='file'
          ref={fileRef}
          style={{ display: 'none' }}
          multiple={fieldName === 'mcqFile' ? false : true}
          onChange={onChange}
          accept={
            fieldName === 'pdfFiles'
              ? 'application/pdf, application/zip, application/x-zip-compressed'
              : fieldName === 'videoFiles'
                ? 'video/*'
                : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          }
        />
        <Button type='button' customClassName={'btn-upload-file'} onClick={handleSelect}>
          <img src={uploadPinIcon} alt='Upload' /> {UI_CONSTANT.ATTACH_MORE}
        </Button>
        {fieldName === 'mcqFile' && (
          <a href={sampleQuestionSet} download='sample_question_set' className='remove-underline'>
            <div className='download-sample-data-btn'>Download Sample Data</div>
          </a>
        )}
      </div>
    </>
  )
}

export default AddTopicDetails
